import React, { Component } from 'react'
import { connect } from 'react-redux';
import Swal from 'sweetalert2';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import 'ag-grid-community/dist/styles/ag-theme-balham.css';
import CKEditor from "react-ckeditor-component";
import { bindActionCreators } from 'redux';
import { AC_ADD_CATEGORY, AC_HANDLE_CATEGORY_CHANGE, AC_LIST_CATEGORY, AC_RESET_CATEGORY, AC_UPDATE_CATEGORY, AC_VIEW_CATEGORY, AC_EMPTY_CATEGORY, AC_LIST_CATEGORY_DRAG_DROP, AC_HANDLE_CATEGORY_SEARCH } from '../../actions/categoryAction';
import axios from 'axios';
import { Link, Redirect } from 'react-router-dom';
import ImportedURL from '../../common/api';
import { Error, Success } from '../../common/swal';
import Select from 'react-select';
import jsPDF from 'jspdf';
import Spinner from 'react-bootstrap/Spinner';
import RLDD from 'react-list-drag-and-drop/lib/RLDD';
import { ListLandingUpdateData, ListLandingUpdateStatus } from '../../common/validate';
import { AC_PUSH_DATA_LANDING } from '../../actions/landing';
import ErrorResponse from '../../utilities/Error/errorstatus';
import showSwalDialog from '../../utilities/Modal/swal';

const initialState = {
    modalType: "Add",
    gridApi: '',

    columnDefs: [
        { headerName: '#', valueGetter: "node.rowIndex+1", width: 100, sortable: false, filter: false, headerClass: 'ag-center-header', cellStyle: { 'text-align': 'center' }, hide: 'true' },
        { headerName: 'Category', field: 'name', width: 300, floatingFilter: false, headerClass: 'ag-center-header', rowDrag: true, },
        {
            headerName: 'Mandatory', width: 250, field: 'mandatory', headerClass: 'ag-center-header', suppressMenu: true, cellStyle: { 'display': 'flex', 'justify-content': 'center' },
            cellRenderer: function (params) {
                if (params.data.mandatory) {
                    return `<div class="status_style mandatory_status_style"><span type="button" class="tag tag-green mandatory_status_style" data-action-type="Mandatory">Mandatory</span></div>`;
                } else {
                    return '<div class="status_style mandatory_status_style"><span type="button" class="tag tag-danger mandatory_status_style" data-action-type="Mandatory">Not Mandatory</span></div>';
                }
            }
        },
        {
            headerName: 'Web Access', width: 200, field: 'webaccess', headerClass: 'ag-center-header', suppressMenu: true, cellStyle: { 'display': 'flex', 'justify-content': 'center' },
            cellRenderer: function (params) {
                if (params.data.webaccess) {
                    return `<div class="status_style webaccess_status_style"><span type="button" class="tag tag-green webaccess_status_style" data-action-type="WebAccess">Allow</span></div>`;
                } else {
                    return '<div class="status_style webaccess_status_style"><span type="button" class="tag tag-danger webaccess_status_style" data-action-type="WebAccess">Deny</span></div>';
                }
            }
        },
        {
            headerName: 'Status', width: 200, field: 'status', headerClass: 'ag-center-header', suppressMenu: true, cellStyle: { 'display': 'flex', 'justify-content': 'center' },
            cellRenderer: function (params) {
                if (params.data.status) {
                    return `<div class="status_style"><span type="button" class="tag tag-green" data-action-type="Status">Active</span></div>`;
                } else {
                    return '<div class="status_style"><span type="button" class="tag tag-danger" data-action-type="Status">Inactive</span></div>';
                }
            }
        },
        {
            headerName: 'Actions', width: 250, field: 'actions', sortable: 'false', headerClass: 'ag-center-header', suppressMenu: true, sortable: false, filter: false,
            cellRenderer: function (params) {
                return params.value;
            }
        },
    ],
    defaultColumDef: {
        editable: false,
        sortable: true,
        resizable: true,
        filter: true,
        flex: 1,
        minWidth: 100,
    },
    nameError: false,
    id: '',
    serachValue: '',
    pagination: 1,
    paginationLimit: 25,
    startLimit: 1,
    endLimit: 25,
}
class ListCategory extends Component {
    constructor(props) {
        super(props);
        this.state = initialState
    }

    changeModal = (e) => {
        this.props.EmptyCategory();
        this.setState({ modalType: e.target.id });
        this.props.ResetCategory();
    }
    onRowClicked = event => {
        const { AccountState } = this.props;
        const languageData = AccountState.account.SelectedlanguageData
        const rowValue = event.event.target;
        const value = rowValue.getAttribute('data-action-type');
        if (value === 'View') {
            // window.open('/view-room-area-inspection/' + event.data._id, '_blank').focus();
            this.setState({ modalType: "View", nameError: false, id: event.data._id, });
        }
        if (value === 'Edit') {
            this.props.EmptyCategory();
            this.setState({ modalType: "Edit", id: event.data._id, nameError: false });
        }
        if (value === 'Delete') {
            showSwalDialog('Are you sure you want to delete?', '', 'Ok', 'Cancel', 'assets/images/delete.png').then((result) => {
                if (result.isConfirmed) {
                    axios.get(ImportedURL.API.softDeleteCategory + '/' + event.data._id)
                        .then((res) => {
                            Success((languageData && languageData.CATEGORY ? languageData.CATEGORY : 'Category') + (languageData && languageData.DELETED_SUCCESSFULLY ? languageData.DELETED_SUCCESSFULLY : ' deleted successfully'));
                            this.props.ListCategory();
                        }).catch(({ response }) => {
                            ErrorResponse(response, languageData)
                        });
                }
            })
        }
        if (value === 'Status') {
            showSwalDialog('Are you sure you want to change the status?', '', 'Ok', 'Cancel', 'assets/images/status.png').then((result) => {
                if (result.isConfirmed) {
                    axios.post(ImportedURL.API.statusChange, { id: event.data._id, status: !event.data.status, model: 'categories' })
                        .then((res) => {
                            this.props.ListCategory();
                            Success((languageData && languageData.STATUS ? languageData.STATUS : ' Status') + (languageData && languageData.UPDATED_SUCCESSFULLY ? languageData.UPDATED_SUCCESSFULLY : " updated successfully"))
                        }).catch(({ response }) => {
                            ErrorResponse(response, languageData)
                        });
                }
            })
        }

        if (value === 'Mandatory') {
            showSwalDialog('Are you sure you want to change the mandatory?', '', 'Ok', 'Cancel', 'assets/images/status.png').then((result) => {
                if (result.isConfirmed) {
                    axios.get(ImportedURL.API.madatoryStatus + '/' + event.data._id)
                        .then((res) => {
                            this.props.ListCategory();
                            Success((languageData && languageData.MANDATORY ? languageData.MANDATORY : ' Mandatory') + (languageData && languageData.UPDATED_SUCCESSFULLY ? languageData.UPDATED_SUCCESSFULLY : " updated successfully"))
                        }).catch(({ response }) => {
                            ErrorResponse(response, languageData)
                        });
                }
            })
        }
        if (value === 'WebAccess') {
            showSwalDialog('Are you sure you want to change the web access?', '', 'Ok', 'Cancel', 'assets/images/status.png').then((result) => {
                if (result.isConfirmed) {
                    axios.get(ImportedURL.API.webAccessStatus + '/' + event.data._id)
                        .then((res) => {
                            this.props.ListCategory();
                            Success((languageData && languageData.WEB_ACCESS ? languageData.WEB_ACCESS : 'Web Access') + (languageData && languageData.UPDATED_SUCCESSFULLY ? languageData.UPDATED_SUCCESSFULLY : " updated successfully"))
                        }).catch(({ response }) => {
                            ErrorResponse(response, languageData)
                        });
                }
            })
        }
    }

    onChange = e => {
        this.setState({ spinner: false })
        const { name, value } = e.target;
        const Error = name + "Error";
        this.setState({ [Error]: false });
        this.props.HandleInputChange(name, value);
    }

    submit = () => {
        this.setState({ spinner: false })
        const { AccountState } = this.props;
        const languageData = AccountState.account.SelectedlanguageData
        const data = this.props.CategoryState.category;
        if (!data.name) this.setState({ nameError: true });
        else {
            if (this.state.modalType === "Add") {
                axios.post(ImportedURL.API.addCategory, data)
                    .then((res) => {
                        Success((languageData && languageData.CATEGORY ? languageData.CATEGORY : 'Category') + (languageData && languageData.CREATED_SUCCESSFULLY ? languageData.CREATED_SUCCESSFULLY : " created successfully"));
                        this.props.ListCategory();
                        this.props.ResetCategory();
                        let btn = document.getElementById("closeModal");
                        btn.click();
                    }).catch(({ response }) => {
                        if (response) {
                            if (response.status == 409) {
                                Error((languageData && languageData.CATEGORY ? languageData.CATEGORY : 'Category') + (languageData && languageData.ALREADY_EXIST ? languageData.ALREADY_EXIST : ' already exist'))
                            } else if (response.status == 400) {
                                Error((languageData && languageData.BAD_REQUEST ? languageData.BAD_REQUEST : 'Bad request'))
                            }
                            else if (response.status == 500) {
                                Error(response.status + (languageData && languageData.INTERNAL_SERVER_ERROR ? languageData.INTERNAL_SERVER_ERROR : ' Internal Server Error'))
                            } else if (response.status == 502) {
                                Error(response.status + (languageData && languageData.BAD_GATEWAY ? languageData.BAD_GATEWAY : ' Bad Gateway'))
                            } else {
                                Error(response.statusMessage)
                            }
                        }
                    });
            } else {
                axios.post(ImportedURL.API.updateCategory + "/" + this.state.id, data)
                    .then((res) => {
                        Success((languageData && languageData.CATEGORY ? languageData.CATEGORY : 'Category') + (languageData && languageData.UPDATED_SUCCESSFULLY ? languageData.UPDATED_SUCCESSFULLY : "updated successfully"));
                        this.props.ListCategory();
                        let btn = document.getElementById("closeModal");
                        btn.click();
                    }).catch(({ response }) => {
                        if (response) {
                            if (response.status == 400) {
                                Error((languageData && languageData.BAD_REQUEST ? languageData.BAD_REQUEST : 'Bad request'))
                            }
                            this.setState({ saving: false })
                        }
                    });
            }
        }
    }

    componentDidMount() {
        this.props.ListCategory();
        this.props.EmptyCategory();
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });

    }
    handleRLDDChange = (e) => {
        if (e && e.length > 0) {
            const formData = {
                category: e
            }
            this.props.CategoryDragDrop(formData)
        }
    }

    exportPDF = () => {
        const account = this.props.AccountState.account;
        const { AccountState } = this.props;
        const api = this.gridApi;
        const filteredRows = api.getModel().rowsToDisplay
        const exportData = filteredRows.map(rowNode => rowNode.data);
        const topHotelName = AccountState.account.hotelName;

        const unit = "pt";
        const size = "A4";
        const orientation = "landscape";

        const marginLeft = 15;

        var img = new Image();
        img.src = '../../assets/images/logo.png';
        const doc = new jsPDF(orientation, unit, size);

        doc.setFontSize(15);

        const title = topHotelName ? topHotelName + ' ' + '-' + ' ' + "Category List" : "Category List";
        if (topHotelName) {
            var headers = [['#', 'Category', 'Mandatory', 'Web Access']];
            var data = exportData.map((elt, i) => [
                i + 1,
                elt.name,
                elt.mandatory ? 'Mandatory' : 'Not Mandatory',
                elt.webaccess ? 'Allowed' : 'Denied',
            ]);
        } else {
            var headers = [['#', 'Category']];
            var data = exportData.map((elt, i) => [
                i + 1,
                elt.name,
                elt.mandatory ? 'Mandatory' : 'Not Mandatory',
                elt.webaccess ? 'Allowed' : 'Denied',
            ]);
        };
        let content = {
            startY: 70,
            head: headers,
            headStyles: { fillColor: [215, 234, 255], textColor: [28, 48, 120], },
            body: data,
            styles: {
                minCellHeight: 30,
                valign: 'middle',
                lineWidth: 0.5,
            },
            margin: {
                left: 10,
                right: 10,
                bottom: 70,
            },
            autoPaging: "text",
        };
        doc.addImage(img, 'png', 780, 6, 50, 50);
        doc.setTextColor(28, 48, 120);
        doc.text(title, marginLeft, 40);
        doc.setTextColor(28, 48, 120);
        // doc.text('MyHotel AI', 710, 40)
        doc.autoTable(content);
        var totalPages = doc.internal.getNumberOfPages();
        for (let i = 1; i <= totalPages; i++) {
            doc.setPage(i);
            doc.setFontSize(11);
            doc.setTextColor(110);
            doc.text('Page ' + i + ' of ' + totalPages, doc.internal.pageSize.getWidth() - 100, doc.internal.pageSize.getHeight() - 20);
            doc.setFontSize(11);
            const fullText = 'This is an auto-generated report from MyHotel AI (www.myhotelai.com)';
            const coloredText = '(www.myhotelai.com)';
            const textColor = [28, 48, 120]; // Specify your desired text color as an RGB array

            const textXPosition = 20;
            const textYPosition = doc.internal.pageSize.getHeight() - 20;
            const fullTextWidth = doc.getTextWidth(fullText);
            const coloredTextWidth = doc.getTextWidth(coloredText);
            const leadingText = fullText.slice(0, fullText.indexOf(coloredText));
            doc.setTextColor(110);
            doc.text(leadingText, textXPosition, textYPosition);
            doc.setTextColor(textColor[0], textColor[1], textColor[2]);
            doc.text(coloredText, textXPosition + fullTextWidth - coloredTextWidth, textYPosition);
        }
        doc.save("categories" + "_" + (topHotelName && (topHotelName).replace(/ /g, '_')) + (account.currentTime).replace(/ /g, '_') + ".pdf")
    }
    changeStatus = (id, value) => {
        const { AccountState } = this.props;
        const languageData = AccountState.account.SelectedlanguageData
        showSwalDialog('Are you sure you want to change the status?', '', 'Ok', 'Cancel', 'assets/images/status.png').then((result) => {
            if (result.isConfirmed) {
                axios.post(ImportedURL.API.statusChange, { id: id, status: value, model: 'categories' })
                    .then((data) => {
                        this.props.ListCategory();
                        Success((languageData && languageData.STATUS ? languageData.STATUS : ' Status') + (languageData && languageData.UPDATED_SUCCESSFULLY ? languageData.UPDATED_SUCCESSFULLY : "updated successfully"))
                    }).catch(({ response }) => {
                        ErrorResponse(response, languageData)
                    });
            }
        })
    }

    changeMandatoryStatus = (id, value) => {
        const { AccountState } = this.props;
        const languageData = AccountState.account.SelectedlanguageData
        showSwalDialog('Are you sure you want to change the mandatory?', '', 'Ok', 'Cancel', 'assets/images/status.png').then((result) => {
            if (result.isConfirmed) {
                axios.get(ImportedURL.API.madatoryStatus + '/' + id)
                    .then((data) => {
                        this.props.ListCategory();
                        Success((languageData && languageData.STATUS ? languageData.STATUS : ' Status') + (languageData && languageData.UPDATED_SUCCESSFULLY ? languageData.UPDATED_SUCCESSFULLY : "updated successfully"))
                    }).catch(({ response }) => {
                        ErrorResponse(response, languageData)
                    });
            }
        })
    }
    changeAction = (id, value) => {
        const { AccountState } = this.props;
        const languageData = AccountState.account.SelectedlanguageData
        if (value === 'View') {
            this.setState({ modalType: "View", nameError: false, id: id, });
        }
        if (value === 'Edit') {
            this.props.EmptyCategory();
            this.setState({ modalType: "Edit", id: id, nameError: false });
        }
        if (value === 'Delete') {
            showSwalDialog('Are you sure you want to delete?', '', 'Ok', 'Cancel', 'assets/images/delete.png').then((result) => {
                if (result.isConfirmed) {
                    axios.get(ImportedURL.API.softDeleteCategory + '/' + id)
                        .then((res) => {
                            Success((languageData && languageData.CATEGORY ? languageData.CATEGORY : 'Category') + (languageData && languageData.DELETED_SUCCESSFULLY ? languageData.DELETED_SUCCESSFULLY : ' deleted successfully'));
                            this.props.ListCategory();
                        }).catch(({ response }) => {
                            ErrorResponse(response, languageData)
                        });
                }
            })
        }
    }

    handleSearch = (e) => {
        var value = e.target.value
        const rowData = this.props.CategoryState.listfilter;
        this.setState({ serachValue: value })
        if (value) {
            if (rowData != undefined && rowData.length > 0) {
                const data = rowData.filter((item) =>
                    item.name.toLowerCase().includes(value.toLowerCase())
                )
                this.props.searchCategoryList(data)
            } else {
                this.props.searchCategoryList([])
            }
        } else {
            this.props.ListCategory();
        }
    }

    handleLimit = (e) => {
        this.setState({ paginationLimit: e, startLimit: 1, endLimit: e })
    }
    previousPage = (e) => {
        const rowData = this.props.CategoryState.listcategories;
        const { pagination, paginationLimit, startLimit, endLimit } = this.state
        if (1 < pagination) {
            this.setState({ startLimit: startLimit - paginationLimit, endLimit: endLimit - paginationLimit, pagination: pagination - 1 })
        }
    }
    nextPage = (e) => {
        const rowData = this.props.CategoryState.listcategories;
        const { pagination, paginationLimit, startLimit, endLimit } = this.state
        if (endLimit < rowData.length) {
            this.setState({ startLimit: endLimit + 1, endLimit: endLimit + paginationLimit, pagination: pagination + 1 })
        }
    }
    firstPage = (e) => {
        const rowData = this.props.CategoryState.listcategories;
        const { pagination, paginationLimit, startLimit, endLimit } = this.state
        if (1 < pagination) {
            this.setState({ startLimit: 1, endLimit: paginationLimit, pagination: pagination - 1 })
        }
    }
    lastPage = (e) => {
        const rowData = this.props.CategoryState.listcategories;
        const { pagination, paginationLimit, startLimit, endLimit } = this.state
        var totalNumber = Math.ceil(rowData.length / paginationLimit)
        if (endLimit < rowData.length) {
            this.setState({ startLimit: (totalNumber * paginationLimit) - paginationLimit, endLimit: (totalNumber * paginationLimit), pagination: totalNumber })
        }
    }
    onGridReady = (params) => {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        this.gridApi.sizeColumnsToFit();
        this.setState({ gridApi: params.api })
    };
    onRowDragEnd = (e) => {
        let arr = []
        this.gridApi.forEachNode((rowNode, index) => {
            arr.push({ id: rowNode.data._id, sort: index })
        });

        axios.post(ImportedURL.API.sortCategory, { data: arr, model: 'categories' })
            .then((res) => {
                this.props.ListCategory();
            }).catch(({ response }) => {
            });
    };
    render() {
        if (this.state.modalType === "View") return <Redirect to={'view-category/' + this.state.id} />
        if (this.state.modalType === "Edit") return <Redirect to={'edit-category/' + this.state.id} />
        const { CategoryState, AccountState } = this.props;
        const rowData = CategoryState.listcategories;
        const languageData = AccountState.account.SelectedlanguageData
        const data = CategoryState.category;
        const spinner = CategoryState.spinner;
        const previleges = AccountState.previleges;
        const Previlege = previleges.find(obj => { return obj.name == "Category" });
        const editOption = Previlege?.edit ? '<button type="button" class="btn btn-icon" data-action-type="Edit"><i class="fa fa-edit" style="color: #2196F3 !important" data-action-type="Edit"></i></button>' : '';
        const deleteOption = ImportedURL.SUPERADMIN.includes(AccountState.role) ? '<button type="button" class="btn btn-icon js-sweetalert" title="Delete" data-action-type="Delete"><i class="fa fa-trash-o text-danger" style="color: red !important" data-action-type="Delete"/></button>' : '';
        const template = '<div class="userlist_view"><button type="button" class="btn btn-icon" data-action-type="View" ><i class="fa fa-eye" style="color: #1DC9B7 !important" data-action-type="View"></i></button>'
            + editOption
            // + deleteOption
            + '</div>'
        rowData.forEach(object => {
            object.actions = template;
        });
        const limitOptions = [
            { value: '25', label: '25' },
            { value: '50', label: '50' },
            { value: '100', label: '100' }
        ]
        const { pagination, paginationLimit, startLimit, endLimit } = this.state
        var startNumber = ''
        var endNumber = ''
        var categoryData = []
        let endvalue = ''
        if (endLimit <= rowData.length) {
            endvalue = endLimit
        } else {
            endvalue = rowData.length
        }
        if (rowData.length > 0) {
            for (let i = startLimit; i <= Number(endvalue); i++) {
                categoryData.push(rowData[i - 1])
            }
        }
        var totalNumber = Math.ceil(rowData.length / paginationLimit)
        return (
            <>
                <div>
                    <div>
                        <div className="breadcrump">
                            <p> <Link to="/"><h6>{languageData && languageData.DASHBOARD ? languageData.DASHBOARD : "Dashboard"}</h6></Link>  <span><i className="fa fa-angle-right" aria-hidden="true"></i> </span>  <Link to="/list-category"><h6 className="highlights_breadcrump">{languageData && languageData.CATEGORIES ? languageData.CATEGORIES : "Categories"}{languageData && languageData.LIST ? languageData.LIST : " List"} </h6></Link></p>
                        </div>
                        <div className="section-body pt-3">
                            <div className="container-fluid">
                                <div className="tab-content">
                                    <div className="tab-pane fade show active" id="Departments-list" role="tabpanel">
                                        <div className="card">
                                            <div className="card-header tit_res">
                                                <div className='d-flex'>
                                                    <div className='rounded_icon'><i className="icon-bar-chart mr-2 "></i></div>
                                                    <div className='d-flex align-items-center'>
                                                        <h3 className="card-title"> {languageData && languageData.CATEGORIES ? languageData.CATEGORIES : "Categories"} {languageData && languageData.LIST ? languageData.LIST : " List"}</h3>
                                                    </div>
                                                </div>

                                                <div className="card-options add_card_options">
                                                    <div className="d-flex justify-content-between align-items-center">
                                                        <ul className="nav nav-tabs page-header-tab">
                                                        </ul>
                                                        <div className="header-action">
                                                            {Previlege?.add ? <Link to='add-category'><button type="button" className="btn btn-primary" data-toggle="modal" data-target="#exampleModal" id='Add' onClick={(e) => this.changeModal(e)}><i className="fe fe-plus mr-2" id='Add' />Add</button></Link> : ''}
                                                        </div>
                                                    </div>
                                                    {rowData && rowData.length > 0 ?
                                                        <>
                                                            <a className="btn btn-primary btn-sm nav-link dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false"><i className="fa fa-download mr-2" aria-hidden="true"></i>Export</a>
                                                            <div className="dropdown-menu">
                                                                {/* <a className="dropdown-item" type='button' onClick={this.exportToCSV}><i className="dropdown-icon fa fa-file-excel-o"></i> Excel</a> */}
                                                                <a className="dropdown-item" type='button' onClick={this.exportPDF}><i className="dropdown-icon fa fa-file-pdf-o"></i> PDF</a>
                                                            </div>
                                                        </>
                                                        : []}
                                                </div>
                                            </div>
                                            <div className="card-body" style={{ padding: "20px 20px 0px 20px" }}>
                                                <div className="row">
                                                    {/* <div className="col-lg-2 col-md-2 col-sm-2 col-xl-3">
                                                        <label className="form-label">{languageData && languageData.LIMIT ? languageData.LIMIT : "Limit"}</label>
                                                        <div className="form-group mb-0">
                                                            <Select
                                                                onChange={(e) => this.handleLimit(Number(e.value))}
                                                                options={limitOptions}
                                                                defaultValue={limitOptions[0]}
                                                                className='limit_size'
                                                            />
                                                        </div>
                                                    </div> */}
                                                    <div className="col-lg-2 col-md-2 col-sm-2 col-xl-3">
                                                        <label className="form-label">{languageData && languageData.CATEGORY ? languageData.CATEGORY : "Category"} {languageData && languageData.SEARCH ? languageData.SEARCH : "Search"}</label>
                                                        <div className="form-group mb-0">
                                                            <input type="text" className="form-control" placeholder="Category Search" name="categorysearch" disabled={this.state.modalType == "View"} onChange={this.handleSearch} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='card-body border-0'>
                                                <div className="table-responsive">
                                                    <div className={(rowData && rowData.length == 0) ? "ag-theme-alpine ag_grid_no_record_show" : "ag-theme-alpine"}>
                                                        <AgGridReact
                                                            rowHeight={82}
                                                            paginationPageSize={25}
                                                            rowData={rowData}
                                                            onRowClicked={this.onRowClicked}
                                                            domLayout={"autoHeight"}
                                                            defaultColDef={this.state.defaultColumDef}
                                                            onGridReady={this.onGridReady}
                                                            columnDefs={this.state.columnDefs}
                                                            onRowDragEnd={this.onRowDragEnd.bind(this)}
                                                            rowDragManaged={true}
                                                            suppressMoveWhenRowDragging={true}
                                                        >
                                                        </AgGridReact>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* <div className="card-body card-footer" style={{ borderTop: "none" }}>
                                                <div className="Over_all_table_style table-responsive edit_user_table_Custom list_cat">
                                                    <table className="table table-striped mb-0">
                                                        <thead>
                                                            <tr>
                                                                <th style={{ background: '#e9f3fe' }}>
                                                                    <span>Category</span>
                                                                    <span style={{ float: "right", marginRight: '85px' }}>
                                                                        <span style={{ marginRight: '85px' }}>Attachment</span>
                                                                        <span style={{ marginRight: "100px" }}>Status</span>
                                                                        <span>Action</span>
                                                                    </span>
                                                                </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                (rowData != undefined && rowData.length > 0)
                                                                    ?
                                                                    <RLDD style={{ width: "100%" }}
                                                                        items={categoryData}
                                                                        itemRenderer={(item, index) => {
                                                                            return (
                                                                                <tr>
                                                                                    <td style={{ width: "50%" }}>{item.name}</td>
                                                                                    <td style={{ width: "20%" }}>
                                                                                        {
                                                                                            item.mandatory
                                                                                                ?
                                                                                                <div class="status_style"><span type="button" class="tag mandatorystatus" onClick={(event) => this.changeMandatoryStatus(item._id, false)} data-action-type="MandatoryStatus">Mandatory</span></div>
                                                                                                :
                                                                                                <div class="status_style"><span type="button" class="tag nonmandatory" onClick={(event) => this.changeMandatoryStatus(item._id, true)} data-action-type="MandatoryStatus">Not mandatory</span></div>
                                                                                        }
                                                                                    </td>
                                                                                    <td style={{ width: "10%" }}>
                                                                                        {
                                                                                            item.status
                                                                                                ?
                                                                                                <div class="status_style"><span type="button" class="tag tag-green" onClick={(event) => this.changeStatus(item._id, false)} data-action-type="Status">Active</span></div>
                                                                                                :
                                                                                                <div class="status_style"><span type="button" class="tag tag-danger" onClick={(event) => this.changeStatus(item._id, true)} data-action-type="Status">Inactive</span></div>
                                                                                        }
                                                                                    </td>
                                                                                    <td style={{ width: "20%" }}>
                                                                                        <div class="userlist_view">
                                                                                            <button type="button" class="btn btn-icon" data-action-type="View" ><i class="fa fa-eye" style={{ color: "#1DC9B7 !important" }} onClick={(event) => this.changeAction(item._id, "View")} data-action-type="View"></i></button>
                                                                                            <button type="button" class="btn btn-icon" data-action-type="Edit"><i class="fa fa-edit" style={{ color: "#2196F3 !important" }} onClick={(event) => this.changeAction(item._id, "Edit")} data-action-type="Edit"></i></button>
                                                                                        </div>
                                                                                    </td>
                                                                                </tr>
                                                                            );
                                                                        }}
                                                                        onChange={this.handleRLDDChange}
                                                                    />
                                                                    :
                                                                    ""
                                                            }
                                                        </tbody>
                                                        <div className='pagination-table'>
                                                            <div className='pagination-style'>
                                                                <span>{startLimit}</span><span >to</span><span>{Number(endvalue)}</span><span >of</span><span>{rowData.length}</span>
                                                                <span style={{ color: "#1c3078" }} onClick={this.firstPage}>
                                                                    <i style={{ cursor: 'pointer' }} class="fa fa-angle-double-left"></i>
                                                                </span>
                                                                <span onClick={this.previousPage}>
                                                                    <i style={{ cursor: 'pointer' }} class="fa fa-angle-left"></i>
                                                                </span>
                                                                <span>page</span><span >{pagination}</span><span>of</span><span>{Number(totalNumber)}</span>
                                                                <span onClick={this.nextPage}>
                                                                    <i style={{ cursor: 'pointer' }} class="fa fa-angle-right"></i>
                                                                </span>
                                                                <span onClick={this.lastPage}>
                                                                    <i style={{ cursor: 'pointer' }} class="fa fa-angle-double-right"></i>
                                                                </span>

                                                            </div>
                                                        </div>
                                                    </table>
                                                </div>
                                            </div> */}
                                            <div id='overlay-model' style={{ display: spinner ? 'block' : 'none' }}></div>
                                            {spinner ?
                                                <div className='common_loader_ag_grid'>
                                                    <img className='loader_img_style_common_ag_grid' src='../../assets/images/load.png' />
                                                    <Spinner className='spinner_load_common_ag_grid' animation="border" variant="info" >
                                                    </Spinner>
                                                </div>
                                                : ""
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Modal */}
                    <div className="modal fade" id="exampleModal" tabIndex={-1} role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                        <div className="modal-dialog" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title" id="exampleModalLabel">{this.state.modalType} {languageData && languageData.CATEGORY ? languageData.CATEGORY : "Category"}</h5>
                                    <button type="button" className="close" id='closeModal' data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true" style={{ fontSize: "23px" }}>
                                            <img src='../../assets/images/cancel.png' />
                                        </span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <div className="row clearfix">
                                        <div className="col-md-12">
                                            <div className="form-group">
                                                <input type="text" className="form-control" disabled={this.state.modalType == "View"} name='name' onChange={this.onChange} value={data.name} placeholder="Category name*" />
                                                <div className="invalid-feedback" style={{ display: this.state.nameError ? "block" : 'none' }}>Category name is required</div>
                                            </div>
                                        </div>
                                        <div className="col-md-12">
                                            <div className="form-group">
                                                <select className="form-control" disabled={this.state.modalType == "View"} name='status' onChange={this.onChange}>
                                                    <option defaultValue={1} selected={data.status == 1}>Active</option>
                                                    <option defaultValue={0} selected={data.status == 0}>Inactive</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {this.state.modalType !== "View" ? <div className="modal-footer" >
                                    <button type="button" className="btn btn-secondary" data-dismiss="modal">Close</button>
                                    <button type="button" className="btn btn-primary" onClick={this.submit}>Save</button>
                                </div> : ""}
                            </div>
                        </div>
                    </div>
                </div >
            </>
        )
    }
}
const mapStateToProps = state => ({
    CategoryState: state.category,
    AccountState: state.account,

})

function mapDispatchToProps(dispatch) {
    return bindActionCreators({ LandingData: AC_PUSH_DATA_LANDING, searchCategoryList: AC_HANDLE_CATEGORY_SEARCH, CategoryDragDrop: AC_LIST_CATEGORY_DRAG_DROP, EmptyCategory: AC_EMPTY_CATEGORY, HandleInputChange: AC_HANDLE_CATEGORY_CHANGE, AddCategory: AC_ADD_CATEGORY, ListCategory: AC_LIST_CATEGORY, ViewCategory: AC_VIEW_CATEGORY, ResetCategory: AC_RESET_CATEGORY, UpdateCategory: AC_UPDATE_CATEGORY, }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(ListCategory);